import Environment from '../../Environment';

interface ISiteLinkProps {
  relativeUrl: string | undefined | null;
  label: string | number | undefined | null;
}

function ISiteLink({ relativeUrl, label }: ISiteLinkProps) {
  return (
    <a href={`${Environment.ISITE_URL()}${relativeUrl}`} target="_blank" rel="noreferrer">
      {label}
    </a>
  );
}

export default ISiteLink;
